import { render } from "./WechatScheduled.vue?vue&type=template&id=669ccd66&scoped=true"
import script from "./WechatScheduled.vue?vue&type=script&lang=js"
export * from "./WechatScheduled.vue?vue&type=script&lang=js"

import "./WechatScheduled.vue?vue&type=style&index=0&id=669ccd66&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669ccd66"]])

export default __exports__